import { AsyncPipe, CommonModule, CurrencyPipe, NgFor, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, PLATFORM_ID, makeStateKey } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable, forkJoin } from 'rxjs';
import { Item, ItemService } from '../../pages/item-detail/item-detail.service';
import { PrerenderDataService } from '../../prerender-data.service';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { CartQtyControlComponent } from '../../pages/cart-qty-control/cart-qty-control.component';
const GET_ALL_ITEMS_SEARCH = makeStateKey<any>('GET_ALL_ITEMS_SEARCH');

@Component({
  selector: 'app-search-results',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    RouterModule,

    CdkScrollableModule,
    CommonModule
  ],
  templateUrl: './search-results.component.html',
  // changeDetection:ChangeDetectionStrategy.OnPush,
  styleUrl: './search-results.component.scss'
})
export class SearchResultsComponent implements OnInit, AfterViewInit {
  searchCtrl = new FormControl('');
  filteredStates?: Observable<Item[]>;
  allItems: Item[] = [];
  searchRes: Item[] = [];
  loaded = false;
  count: number=0;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private prerenderDataService: PrerenderDataService,
    private itemService: ItemService, public dialog: Dialog,
    private dialogRef: DialogRef<SearchResultsComponent>,
    // private changeDetectorRef: ChangeDetectorRef
  ) {

    if (isPlatformServer(this.platformId)) {
      console.log('server sync');

      this.loadFromService()

    }
    if (isPlatformBrowser(this.platformId)) {
      this.allItems = this.prerenderDataService.getPreloadedData(GET_ALL_ITEMS_SEARCH);

      if (this.allItems === null || this.allItems === undefined) {
        this.loadFromService()

      } else {
        this.loaded = true;
        this.getSearchResults()

      }

      // this.getSearchResults()

    }

    this.searchCtrl.valueChanges.subscribe(e => {
      this.getSearchResults()
    })

  }
  ngAfterViewInit(): void {


  }
  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      this.loadFromService()
    }
  }
  loadFromService() {
    this.allItems = []
    this.itemService.getAllCats().subscribe(categories => {

      const observables = categories.map(category => {
        return this.itemService.getItemAll(category.slug!);
      });

      forkJoin(observables).subscribe(itemsArrays => {
        itemsArrays.forEach(items => {
          this.allItems.push(...items);
        });
        this.count=this.allItems.length;
        this.prerenderDataService.setPreloadedData(GET_ALL_ITEMS_SEARCH, this.allItems);
        this.allItems = this.prerenderDataService.getPreloadedData(GET_ALL_ITEMS_SEARCH);
        this.loaded = true;
        this.getSearchResults()


      });
    });

  }

  getSearchResults() {
    if (this.searchCtrl.value!.toString().length > 0) {
      this.searchRes = this.allItems.filter(e => this.createRegex(this.searchCtrl.value!).test(e.label!))
    } else {
      this.searchRes = this.pickRandom(this.allItems, 20)
    }
  }
  pickRandom(arr: any, count: number) {
    const picked = [];
    for (let i = 0; i < count; i++) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      picked.push(arr[randomIndex]);
    }
    return picked;
  }
  createRegex(searchTerm: string): RegExp {
    // Escape special characters in the search term to prevent errors
    const escapedSearchTerm = searchTerm.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    return new RegExp(`\\b${escapedSearchTerm}\\w*`, 'i');  // Case-insensitive
  }


  close() {
    this.dialogRef.close()
  }
  @HostListener("click", ["$event"])
  handleLike($event: any, itm: Item) {
    $event.stopPropagation();
    this.open(itm)
  }

  open(itm: Item) {
    if (itm !== undefined)
      if (itm.slug !== undefined)
        // this.createImageSet();
        this.dialog.open(CartQtyControlComponent, {
          width: '100vw',
          minHeight: '100%',
          height: '100vh',
          // minHeight: '100%',
          data: {
            product: itm,
            images: new Set<string>()
          },
          hasBackdrop: true,
          disableClose: false

        });
  }
}
